import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import no from "vuetify/es5/locale/no";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#c8102e",
        secondary: "#b0bec5",
        accent: "#c8102e",
        error: "#b71c1c",
      },
    },
  },
  lang: {
    locales: { no },
    current: "no",
  },
});
